
import { HttpHeaders } from '@angular/common/http';
const readStoredTokens = (): { token?: string; idToken?: string } => {
  try {
    return JSON.parse(sessionStorage.getItem('token') || '{}');
  } catch {
    return {};
  }
};

export const getStoredAccessToken = (): string | null =>
  readStoredTokens().token ?? null;

export const getStoredIdToken = (): string | null =>
  readStoredTokens().idToken ?? null;
const getHeaderObject = () => ({
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + getStoredIdToken(),
});

const getLogtoHeaderObject = () => ({
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + getStoredAccessToken(),
});

export const httpHeader = {
  get token() {
    return getStoredAccessToken();
  },
  get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  },

  // For Logto's own APIs (like /api/my-account)
  get logtoHttpOptions() {
    return {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getStoredIdToken(),
      },
    };
  },

  customHttpOptions: (obj: any) => {
    return {
      headers: new HttpHeaders({
        ...getHeaderObject(),
        ...obj,
      }),
    };
  },

  customLogtoHttpOptions: (obj: any) => {
    return {
      headers: new HttpHeaders({
        ...getLogtoHeaderObject(),
        ...obj,
      }),
    };
  },

  get httpMultiOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        Authorization: 'Bearer ' + getStoredIdToken(),
      }),
    };
  },
};
